import api from "../base-url";
import { mutate } from 'swr';

async function deleteVersions(id: number, appID: number) {
  
  try {
  let res = await api.delete(`/versions/${id}`);
  console.log("status", res.status)
  
  if(res.status >= 200 && res.status < 300) {
    mutate(`/apps/${appID}`);
    mutate('/apps');
    console.log("appid", appID)
  }

  return res.status; }
 catch (error: any) {
    if (error.response) {
    console.log("error status", error.response.status)
    return error.response.status
  }
}}


export default deleteVersions;
